// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__N-JOJ","loader":"Loader_loader__xk3ie"};